import classNames from "classnames";
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import styled from "styled-components";
import withControlledVisibility from "../../HOCs/withControlledVisibility";
import { useViewState } from "../../Context";
import LangPanel from "../Panels/LangPanel/LangPanel";
import SettingPanel from "../Panels/SettingPanel";
import SharePanel from "../Panels/SharePanel/SharePanel";
import ToolsPanel from "../Panels/ToolsPanel/ToolsPanel";
import StoryButton from "./StoryButton/StoryButton";
import HelpButton from "./HelpButton/HelpButton";
import Styles from "./menu-bar.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const StyledMenuBar = styled.div.withConfig({
  displayName: "MenuBar__StyledMenuBar",
  componentId: "sc-zwkk1s-0"
})(["pointer-events:none;", ""], p => p.trainerBarVisible && "\n    top: ".concat(Number(p.theme.trainerHeight) + Number(p.theme.mapButtonTop), "px;\n  "));
// The map navigation region
const MenuBar = observer(props => {
  var _terria$configParamet;
  const viewState = useViewState();
  const terria = viewState.terria;
  const menuItems = props.menuItems || [];
  const handleClick = () => {
    runInAction(() => {
      viewState.topElement = "MenuBar";
    });
  };
  const storyEnabled = terria.configParameters.storyEnabled;
  const enableTools = terria.userProperties.get("tools") === "1";
  return /*#__PURE__*/_jsxs(StyledMenuBar, {
    className: classNames(viewState.topElement === "MenuBar" ? "top-element" : "", Styles.menuBar, {
      [Styles.menuBarWorkbenchClosed]: viewState.isMapFullScreen
    }),
    onClick: handleClick,
    trainerBarVisible: viewState.trainerBarVisible,
    children: [/*#__PURE__*/_jsx("section", {
      children: /*#__PURE__*/_jsxs("ul", {
        className: classNames(Styles.menu),
        children: [enableTools && /*#__PURE__*/_jsx("li", {
          className: Styles.menuItem,
          children: /*#__PURE__*/_jsx(ToolsPanel, {})
        }), !viewState.useSmallScreenInterface && props.menuLeftItems.map((element, i) => /*#__PURE__*/_jsx("li", {
          className: Styles.menuItem,
          children: element
        }, i))]
      })
    }), /*#__PURE__*/_jsxs("section", {
      className: classNames(Styles.flex),
      children: [/*#__PURE__*/_jsxs("ul", {
        className: classNames(Styles.menu),
        children: [/*#__PURE__*/_jsx("li", {
          className: Styles.menuItem,
          children: /*#__PURE__*/_jsx(SettingPanel, {})
        }), /*#__PURE__*/_jsx("li", {
          className: Styles.menuItem,
          children: /*#__PURE__*/_jsx(HelpButton, {
            viewState: viewState
          })
        }), (_terria$configParamet = terria.configParameters) !== null && _terria$configParamet !== void 0 && (_terria$configParamet = _terria$configParamet.languageConfiguration) !== null && _terria$configParamet !== void 0 && _terria$configParamet.enabled ? /*#__PURE__*/_jsx("li", {
          className: Styles.menuItem,
          children: /*#__PURE__*/_jsx(LangPanel, {
            terria: terria,
            smallScreen: viewState.useSmallScreenInterface
          })
        }) : null]
      }), storyEnabled && /*#__PURE__*/_jsx("ul", {
        className: classNames(Styles.menu),
        children: /*#__PURE__*/_jsx("li", {
          className: Styles.menuItem,
          children: /*#__PURE__*/_jsx(StoryButton, {
            terria: terria,
            viewState: viewState,
            theme: props.theme
          })
        })
      }), /*#__PURE__*/_jsx("ul", {
        className: classNames(Styles.menu),
        children: /*#__PURE__*/_jsx("li", {
          className: Styles.menuItem,
          children: /*#__PURE__*/_jsx(SharePanel, {
            terria: terria,
            viewState: viewState,
            animationDuration: props.animationDuration
          })
        })
      }), !viewState.useSmallScreenInterface && menuItems.map((element, i) => /*#__PURE__*/_jsx("li", {
        className: Styles.menuItem,
        children: element
      }, i))]
    })]
  });
});
MenuBar.displayName = "MenuBar";
MenuBar.propTypes = {
  animationDuration: PropTypes.number,
  menuItems: PropTypes.arrayOf(PropTypes.element),
  menuLeftItems: PropTypes.arrayOf(PropTypes.element)
};
export default withControlledVisibility(MenuBar);